<style scoped>
/* /deep/ .ivu-modal-body {
  padding: 0;
} */
</style>

<template>
  <div>
    <Button @click="showModal=true">打开Modal</Button>
    <Modal v-model="showModal" title="编辑用户" :footer-hide="true">
      <editusercomponent v-model="showModal" v-if="showModal" :userguid="this.stringutil.uuid()"></editusercomponent>
    </Modal>
  </div>
</template>

<script>
import editusercomponent from "./editusercomponent";
export default {
  components: {
    editusercomponent
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    confirm() {}
  },
  mounted() {}
};
</script>